import CheckboxItem from './CheckboxItem';
import { CheckboxItemProps, CheckboxItemValueProps } from './types';

export type { CheckboxItemProps, CheckboxItemValueProps };
export default CheckboxItem;
